import {
  Check,
  FileEdit,
  FileMinus2,
  FilePlus2,
  Footprints,
  Gavel,
  Import,
  ListChecks,
  ListPlus,
  ListX,
  Lock,
  LucideIcon,
  Pencil,
  PencilLine,
  Play,
  Plus,
  Quote,
  RotateCw,
  Send,
  UserMinus,
  Star,
  Trash2,
  Unlock,
  UserCheck,
  Upload,
  X,
} from "lucide-react";

import type { AuditEventType } from "../../../models/audit/auditEvent";

/**
 * One lucide icon per event family. Keyed as `Record<AuditEventType, ...>`
 * (not a lookup function) so a future addition to the backend enum
 * fails `tsc` here rather than silently falling back to a default icon.
 */
export const ICON_BY_EVENT_TYPE: Record<AuditEventType, LucideIcon> = {
  test_created: FilePlus2,
  session_renamed: PencilLine,
  session_deleted: Trash2,
  template_changed: FileEdit,
  control_config_edited: Pencil,
  test_run: Play,
  sample_rerun: RotateCw,
  cell_rerun: RotateCw,
  column_rerun: RotateCw,
  documents_rematched: RotateCw,
  manual_override: UserCheck,
  support_data_cell_edited: Pencil,
  walkthrough_step_edited: Footprints,
  walkthrough_verdict_edited: Gavel,
  walkthrough_citation_imported: Import,
  reperformance_step_added: ListPlus,
  reperformance_step_edited: ListChecks,
  reperformance_step_deleted: ListX,
  sample_row_added: Plus,
  sample_row_edited: PencilLine,
  sample_row_deleted: Trash2,
  sample_upload_confirmed: Upload,
  citation_added: Quote,
  citation_updated: Quote,
  citation_deleted: Quote,
  citation_marked_key: Star,
  result_locked: Lock,
  result_unlocked: Unlock,
  result_deleted: Trash2,
  evidence_added: FilePlus2,
  evidence_removed: FileMinus2,
  submitted_for_review: UserCheck,
  approval_requested: Send,
  approval_approved: Check,
  approval_rejected: X,
  member_removed: UserMinus,
};
